import React from "react";
import PropTypes from "prop-types";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import "../App.css";
import interactionPlugin from "@fullcalendar/interaction";

function TabKentta(props: {
  children: any;
  value: number;
  index: number;
  arena: string;
  events: any;
  dateClick: any;
}) {
  const { value, index, arena, events, dateClick } = props;

  const arena_events = events.filter(
    (event: any) => event.arena_number === parseInt(arena)
  );
  return (
    <div hidden={value > 3} id={`simple-tabpanel-${index}`}>
      {value < 4 && (
        <div>
          <br></br>
          {/* <ArenaMap index={index}></ArenaMap> */}
          <FullCalendar
            events={arena_events}
            locale="fi"
            timeZone="Europe/Helsinki"
            initialView="timeGridWeek"
            slotMinTime="07:00"
            slotMaxTime="22:00"
            firstDay={1}
            weekNumbers={true}
            // weekLabel="viikko"
            allDaySlot={false}
            slotLabelInterval="00:30"
            slotLabelFormat={{
              hour: "numeric",
              minute: "2-digit",
              omitZeroMinute: false,
              meridiem: "short",
            }}
            plugins={[timeGridPlugin, interactionPlugin]}
            dateClick={(info: any) => dateClick(info, arena)}
            buttonText={{
              today: "Tänään",
              month: "Kuukausi",
              week: "Viikko",
              day: "Päivä",
              list: "Lista",
            }}
            businessHours={{
              daysOfWeek: [1, 2, 3, 4, 5],
              startTime: "17:00",
              endTime: "21:00",
            }}
            displayEventTime={false}
            contentHeight={600}
          />
        </div>
      )}
    </div>
  );
}

TabKentta.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default TabKentta;
